import { NEW_PARTNER_REQUESTS } from "../actions/types";

// The Partners page keeps its requests to itself; only the sidebar badge's count
// of new requests is shared
const initialState = {
  newCount: 0,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case NEW_PARTNER_REQUESTS:
      return {
        ...state,
        newCount: payload,
      };
    default:
      return state;
  }
}
